import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { ImageLazyLoad } from '../../';
import Youtube from 'react-youtube';
import './styles.scss';

const propTypes = {
  video: PropTypes.object,
  tracker: PropTypes.func,
};

class LiveCamVideoResult extends React.Component {

  constructor(props) {
    super(props);
    this.state = {showVideo: false}
    this.playVideo = this.playVideo.bind(this);
    this.stateChanged = this.stateChanged.bind(this);
  }

  playVideo() {
    this.setState({showVideo: true});
  }

  stateChanged(event) {
    if(event.data === 1) {
      this.props.tracker(event.target);
    }
  }

  render() {
    const { video, hideTitle } = this.props;
    const { showVideo } = this.state;
    let loaderProps = { style: { height:270 }, dark: true }
    let opts = {
      height: '390',
      width: '640',
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 1,
        autohide: 1,
        modestbranding: 1,
        showinfo: 0,
        rel: 0,
      }}

    return (
      <div className="row search-result-item livecam-video-result" onClick={this.playVideo}>
        <div className="col">
          <div className="result-info-box">
            <div className={(!hideTitle) ? "video-result-image-wrapper" : "video-result-image-wrapper hide-title"}>
              <div className="livecam-video-hover-info"><div className="u-font-foundation-light hover-text">Watch Video</div></div>
              {video.thumbnail && !showVideo &&
                  <ImageLazyLoad src={video.thumbnail.replace('http://', 'https://')} loaderProps={loaderProps} minHeight={(!hideTitle) ? 360 : 330} onClick={this.playVideo} />
                  }
              {showVideo &&
                <div className="embed-responsive">
                  <Youtube
                  ref="resultVideo"
                  videoId={video.video_id}
                  opts={opts}
                  onStateChange={this.stateChanged}
                  />
                </div>
              }
            </div>
            {!hideTitle &&
              <div className="result-text-info">
                <h2>{video.title}</h2>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

LiveCamVideoResult.propTypes = propTypes;

export default LiveCamVideoResult;
